export default __webpack_public_path__ + "static/media/think-illustration-transparent.c58a1dd5.png";